export default "__VITE_ASSET__302d4bb1__"